export enum EvaluationConflictClaimStatus {
  PENDING = 0,
  IN_PROGRESS = 10,
  COMPLETED = 20,
  FAILED = 30,
}
